let o = {};
const g = (t) => {
  o = t;
}, n = () => o;
export {
  n as getConfig,
  g as setConfig
};
